
import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import TextField from "@material-ui/core/TextField/index";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";

const initialValues = {
  name: "",
  deviceModelId:""
};

export default function Edit(props) {
  const { onHide, id, show, onDeviceTypeChoose, onDeviceTypes , orderBy, sortField, skip, take, filterInputs,} = props;
  const [isError, setIsError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [chooseOption, setChooseOption] = useState([]);

  const EditSchema = Yup.object().shape({
    name: Yup.string()
      .required('Ad tələb olunur.'),
  })



  const onPutDeviceType = ( values,resetForm, setSubmitting) => {
    setIsLoading(true);

    axios
      .put(
        `${process.env.REACT_APP_API_URL}deviceType/${id}`,
        {
          id: id,
          name: values.name,
          deviceModelId:chooseOption
        },
       
      )
      .then(() => {
        onDeviceTypes( orderBy, sortField, skip, take, filterInputs)
        resetForm();
        setSubmitting(false);
        onHide(false);
        setIsLoading(false);

      })
      .catch(
        ({
          response: {
            data: { message },
          },
        }) => {
          setIsError(message);
          setIsLoading(false);

        }
      );
  };

  const getInputClasses = (filedName) => {
    if (formik.touched[filedName] && formik.errors[filedName]) {
      return true;
    }
    if (formik.touched[filedName] && !formik.errors[filedName]) {
      return false;
    }

    return false;
  };

  const formik = useFormik({
    initialValues,
    validationSchema: EditSchema,
    onSubmit: (values, { resetForm, setSubmitting }) => {
      onPutDeviceType(values, resetForm, setSubmitting);
    },
  });

  const resetForm = () => {
    onHide();
    formik.resetForm();
  };
  const { setFieldValue } = formik



  useEffect(() => {
    setIsLoading(true)
    onDeviceTypeChoose(id)
      .then((res) => {
        setFieldValue('name', res.data.name)

        setChooseOption(
      
        
        res.data.deviceModel.id);
        setFieldValue('deviceModelId', res.data.deviceModelId)

        setIsLoading(false)
        setIsError(false)
      })
      .catch((err) => {
        setIsLoading(false)
        setIsError(true)
      })
  }, [id, onDeviceTypeChoose, setFieldValue])

 
  return (
    <Modal
      onHide={resetForm}
      show={show}
      size="md"
      aria-labelledby="edit"
      centered
      className="modal pr-0"
    >
      <form onSubmit={formik.handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title id="Edit">Düzəliş et</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="col-12 pl-4 pr-4">
            <div className="row">
              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="name"
                    name="name"
                    label="Ad"
                    placeholder="Ad"
                    className="w-100"
                    error={getInputClasses('name')}
                    {...formik.getFieldProps('name')}
                  />
                </div>
                {formik.touched.name && formik.errors.name ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.name}</div>
                  </div>
                ) : null}
              
                {isError && (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block MuiFormLabel-root Mui-error">
                      {isError}
                    </div>
                  </div>
                )}
              </div> 
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="light"
            onClick={() => {
              onHide(false);
              formik.resetForm();
            }}
          >
            Ləğv et
          </Button>
          <Button type="submit" className={isLoading ? "px-9" : ""}>
            <span>Düzəliş et</span>
            {isLoading && <span className="ml-3 spinner spinner-white"></span>}
          </Button>

        </Modal.Footer>
      </form>
    </Modal>
  );
}
